<template>
  <div>
    <b-overlay
      :show="loading"
      bg-color="transparent"
    >
      <b-card
        v-for="(item,pcindex) in dataList"
        :key="item.id"
        no-body
      >
        <b-card-header>
          <b-card-title>
            {{ item.title }}
          </b-card-title>
          <div>
            <b-button
              v-if="item.privates.length > 0"
              variant="flat-danger"
              size="sm"
              pill
              class="mr-1"
              @click="resetInstallments(item.id)"
            >
              <FeatherIcon icon="Trash2Icon" />
              Özel Ayarları Sil
            </b-button>
            <b-button
              variant="light"
              size="sm"
              pill
              @click="openModal(pcindex)"
            >
              <FeatherIcon icon="EyeIcon" />
              Varsayılan Ayarları Göster
            </b-button>
          </div>
        </b-card-header>
        <b-table-simple
          v-if="item.privates.length > 0"
          striped
          bordered
        >
          <b-thead>
            <b-tr>
              <b-th>Tanım</b-th>
              <b-th class="width-200 text-center">
                Vade Ay
              </b-th>
              <b-th class="width-200 text-center">
                Vade Farkı
              </b-th>
              <b-th class="width-50 text-center">
                <FeatherIcon icon="Trash2Icon" />
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="(ditem,index) in item.privates"
              :key="ditem.id"
            >
              <template v-if="index > 0">
                <b-td class="px-1">
                  <b-form-input
                    v-model="ditem.title"
                    placeholder="Tanım"
                    size="sm"
                  />
                </b-td>
                <b-td
                  class="width-200 text-center px-1"
                >
                  <b-input-group size="sm">
                    <b-input-group-prepend is-text>
                      Ay
                    </b-input-group-prepend>
                    <cleave
                      v-model="ditem.installment"
                      class="form-control form-control-sm"
                      :raw="true"
                      :options="options.number"
                      placeholder="Taksit Sayısı"
                    />
                  </b-input-group>
                </b-td>
                <b-td
                  class="width-200 text-center px-1"
                >
                  <b-input-group size="sm">
                    <b-input-group-prepend is-text>
                      %
                    </b-input-group-prepend>
                    <cleave
                      :id="index"
                      v-model="ditem.rate"
                      class="form-control form-control-sm"
                      :raw="false"
                      :options="options.number"
                      placeholder="Vade Farkı"
                    />
                  </b-input-group>
                </b-td>
                <b-td
                  class="px-1 text-center"
                >
                  <b-button
                    v-if="ditem.id"
                    variant="flat-danger"
                    size="sm"
                    pill
                    class="btn-icon"
                    @click="removeData(ditem.id)"
                  >
                    <FeatherIcon icon="Trash2Icon" />
                  </b-button>
                </b-td>
              </template>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-card-footer>
          <b-alert
            v-if="item.privates.length === 0"
            variant="primary"
            show
            class="mt-1"
          >
            <div class="alert-body text-center py-2">
              <div class="mb-1 font-medium-2 font-weight-bolder">
                Müşteriye özel taksit ayarları bulunmamaktadır.
              </div>
              <b-button
                variant="primary"
                pill
                @click="cloneInstallments(item.id)"
              >
                Özel Taksit Tablosu Oluştur
              </b-button>
            </div>
          </b-alert>
          <div
            v-else
            class="d-flex justify-content-between align-items-center"
          >
            <b-button
              variant="success"
              size="sm"
              @click="saveBatchData(pcindex)"
            >
              <FeatherIcon icon="SaveIcon" />
              Kaydet
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              @click="addRow(pcindex)"
            >
              <FeatherIcon icon="PlusCircleIcon" />
              Taksit Ekle
            </b-button>
          </div>
        </b-card-footer>
      </b-card>
      <div class="text-center">
        <b-button
          variant="danger"
          pill
          @click="cloneInstallments"
        >
          Tüm Bankalar için Özel Taksit Tablosu Oluştur
        </b-button>
      </div>
    </b-overlay>
    <b-modal
      v-model="modalData.status"
      :title="modalData.title"
      size="lg"
      hide-footer
      centered
    >
      <b-table-simple
        striped
        bordered
      >
        <b-thead>
          <b-tr>
            <b-th>Tanım</b-th>
            <b-th class="width-200 text-center">
              Vade Ay
            </b-th>
            <b-th class="width-200 text-center">
              Vade Farkı
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="(mItem,index) in modalData.dataList"
            :key="mItem.id"
          >
            <template v-if="index > 0">
              <b-td>
                {{ mItem.title }}
              </b-td>
              <b-td class="width-200 text-center">
                {{ mItem.installment | toNumbers }}
              </b-td>
              <b-td class="width-200 text-center">
                %{{ mItem.rate | toCurrency }}
              </b-td>
            </template>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-modal>
  </div>
</template>
<script>
import {
  BCard, BTableSimple, BThead, BTbody, BTr, BTh, BTd, BAlert,
  BButton, BCardHeader, BCardTitle, BCardFooter, BFormInput,
  BInputGroupPrepend, BInputGroup, BModal, BOverlay,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'

export default {
  name: 'PrivateInstallments',
  components: {
    BInputGroup,
    BInputGroupPrepend,
    BCard,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BAlert,
    BButton,
    BCardHeader,
    BCardTitle,
    BCardFooter,
    BFormInput,
    Cleave,
    BModal,
    BOverlay,
  },
  data() {
    return {
      modalData: {
        status: false,
        title: null,
        dataList: [],
      },
      options: {
        number: {
          numeral: true,
          numeralDecimalMark: ',',
        },
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['posInstallments/customerInstallments']
    },
    loading() {
      return this.$store.getters['posInstallments/loading']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    addRow(index) {
      this.dataList[index].privates.push({
        id: null,
        title: null,
        installment: null,
        rate: '0.00',
        id_pos_configs: this.dataList[index].id,
        id_customers: this.$route.params.id,
        is_private: '1',
      })
    },
    openModal(index) {
      this.modalData.status = true
      this.modalData.title = this.dataList[index].title
      this.modalData.dataList = this.dataList[index].defaults
    },
    getDataList() {
      this.$store.dispatch('posInstallments/getCustomerInstallments', {
        id_customers: this.$route.params.id,
      })
    },
    cloneInstallments(id = null) {
      this.$store.dispatch('posInstallments/cloneInstallments', {
        id_customers: this.$route.params.id,
        id_pos_configs: Number(id) || null,
      })
        .then(response => {
          if (response.status) {
            this.getDataList()
          }
        })
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('posInstallments/removeData', id)
            .then(response => {
              if (response.status) {
                this.$swal({
                  icon: 'success',
                  title: this.$store.state.app.removeResultTitle,
                  text: this.$store.state.app.removeResultMessage,
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.getDataList()
              }
            })
        }
      })
    },
    resetInstallments(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('posInstallments/resetInstallments', {
            id_customers: this.$route.params.id,
            id_pos_configs: Number(id) || null,
          })
            .then(response => {
              if (response.status) {
                this.getDataList()
              }
            })
        }
      })
    },
    saveBatchData(index) {
      this.$store.dispatch('posInstallments/saveBatchData', this.dataList[index].privates)
        .then(response => {
          if (response.status) {
            this.getDataList()
          }
        })
    },
  },
}
</script>
